<template>
  <div class="contract-editor">
    <module-header>Создание нового подрядчика</module-header>
    <row :gutter="16">
      <i-col span="6">
        <steps-block :steps="steps" :step="step" @change-step="changeStep" />
        <alert
          style="margin-top: 16px;"
          v-if="editorState.warning"
          class="alerts-item"
          type="warning"
        >
          Заполнение информации
          <template slot="desc">{{ editorState.warning }}</template>
        </alert>
      </i-col>
      <i-col span="18">
        <step-container
          :step="step"
          :steps="steps"
          :contract="contract"
          @change-step="changeStep"
          @complete="saveContract"
        />
        <div class="contract-editor__buttons">
          <i-button
            type="success"
            size="default"
            @click="saveContract"
            :loading="saving"
            :disabled="editorState.disabled"
          >
            Создать подрядчика
          </i-button>
        </div>
      </i-col>
    </row>
  </div>
</template>

<script>
import moment from 'moment'
import cloneDeep from 'lodash.clonedeep'
import ModuleHeader from '@/components/parts/module-header'
import StepsBlock from './steps-block'
import StepContainer from './steps/step-container'
import {
  commonInfo,
  roadMap,
  documents,
  requiredCommonFields
} from '@/config/contracts'
import { steps } from '@/config/contragents'
import {
  isRoadmapInvalid,
  getDataFromSS,
  saveDataToSS,
  modifyRoadmapsDates
} from '@/utils'

export default {
  components: {
    ModuleHeader,
    StepsBlock,
    StepContainer
  },
  data () {
    return {
      id: this.$route.query.id,
      step: 0,
      contract: null,
      saving: false,
      saved: false,
      steps
    }
  },
  computed: {
    editorState () {
      // common info
      if (requiredCommonFields.some(f => !this.contract[f])) {
        return {
          warning:
            'Необходимо указать шифр, номер, название, дату заключения, заказчика и исполнителя',
          disabled: true
        }
      }
      if (!this.contract.contract_job_types.length) {
        return {
          warning: 'Необходимо указать как минимум один вид работ',
          disabled: true
        }
      }
      // roadmap
      if (!this.contract.roadmaps.length) {
        return {
          warning: 'В календарном плане должен быть как минимум один этап',
          disabled: true
        }
      }
      if (this.contract.roadmaps.some(isRoadmapInvalid)) {
        return {
          warning:
            'Необходимо указать корректные сумму, сроки и название для каждого этапа календарного плана',
          disabled: true
        }
      }

      return {
        warning: null,
        disabled: false
      }
    },
    isSavingDisabled () {
      // common info
      if (requiredCommonFields.some(f => !this.contract[f])) return true
      if (!this.contract.contract_job_types.length) return true
      // roadmap
      if (!this.contract.roadmaps.length) return true
      if (this.contract.roadmaps.some(isRoadmapInvalid)) return true

      return false
    }
  },
  methods: {
    changeStep (step) {
      this.step = step
    },
    getData () {
      const data = cloneDeep(this.contract)

      data.contract_job_types = data.contract_job_types.map(job_type_id => ({
        job_type_id
      }))
      data.mandatory_file_types = data.mandatory_file_types.map(
        file_type_id => ({
          file_type_id
        })
      )

      data.parent_id = this.$route.query.contract_id

      // modify roadmaps
      data.roadmaps = modifyRoadmapsDates(data.roadmaps)

      // modify sign date
      data.sign_date = moment(data.sign_date).format('YYYY-MM-DD')

      if (!data.id) delete data.id

      return data
    },
    async saveContract () {
      const { contract_id } = this.$route.query

      try {
        this.saving = true
        const url = `page/contragent`
        const data = this.getData()
        await this.$store.dispatch('POST_REQUEST', { url, data })
        sessionStorage.removeItem('creatingContragent')
        this.$Message.success('Сохранение подрядчика выполнено успешно')
        this.saved = true
        this.saving = false
        this.$router.push(`/app/contracts/${contract_id}/contragents`)
      } catch (error) {
        console.log(error)
        const message = error.response.data[0] || 'Произошла ошибка при сохранении объекта'
        this.$Message.error(message)
        this.saving = false
      }
    },
    async getContractInfo () {
      const { contract_id } = this.$route.query

      if (!contract_id) return

      try {
        const url = `page/project/${contract_id}`
        const contract = await this.$store.dispatch('GET_REQUEST', { url })
        const { code, name, performer_id } = contract
        this.contract.code = code
        this.contract.name = name
        this.contract.customer_id = performer_id
      } catch (error) {
        console.log(error)
      }
    },
    getInitialContragent () {
      return {
        ...commonInfo,
        ...cloneDeep(roadMap),
        ...cloneDeep(documents)
      }
    }
  },
  created () {
    this.contract = getDataFromSS(
      'creatingContragent',
      this.getInitialContragent()
    )
    this.getContractInfo()
  },
  beforeDestroy () {
    if (!this.contract.id && !this.saved) { saveDataToSS('creatingContragent', this.contract) }
  }
}
</script>

<style lang="less">
.contract-editor {
  &__buttons {
    display: flex;
    justify-content: flex-end;
    margin-top: 16px;
  }
}
</style>
